import React, { useState } from "react";

import PageHeader from "./../../components/PageHeader";
import ArrowRow from "./../../components/ArrowRow";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Images } from "../../assets/common";
import { Swap, Plus } from "react-iconly";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Tabs,
  Tab,
  Stack,
  Slide,
  Typography,
  Button,
  OutlinedInput,
  InputAdornment,
  Divider,
} from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import {
  getUsdt,
  getHbar,
  getToken,
  getWalletId,
  serialize,
  getErrorString,
  getMemo, getUserDetail,
} from "../../constants/function";
import TransactionRow from "../../components/TransactionRow";
import NoData from "../../components/Nodata";
import notifier from "../../components/Notifier";
import OffboardingBox from "../../components/OffboardingBox";
import QrPopup from "../../components/QrPopup";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LivestreamPayPopup from "../../components/LivestreamPayPopup";
import MonetizationChart from "../../components/Homev2/MonetizationChart";
import { buildPaypalCashoutPayload } from "./paypal-cashout";
function BalanceBox({
  img,
  balance,
  currency,
  accountId,
  onWalletCreate,
  creating,
  notMatic,
  isHbar,
  createMatic,
  isNear,
  createNear,
  loading,
}) {
  const theme = useTheme();
  const palette = theme.palette || {};
  const paperColor =
    palette.background?.paper || "var(--paper-color, #090909)";
  const dividerColor =
    palette.divider ||
    `${palette.primary?.main || "var(--primary-color, #FFEE20)"}33`;
  const placeholderColor =
    palette.mode === "light"
      ? "rgba(0, 0, 0, 0.08)"
      : "rgba(255, 255, 255, 0.14)";
  return (
    <Box
      className="_flex_width"
      sx={{
        padding: "15px",
        backgroundColor: paperColor,
        borderRadius: "16px",
        border: `1px solid ${dividerColor}`,
        width: "30%",
        marginBottom: "1rem",
        boxShadow:
          palette.mode === "light"
            ? "0 14px 30px rgba(0, 0, 0, 0.08)"
            : "0 14px 30px rgba(0, 0, 0, 0.45)",
      }}
    >
      <Stack direction="row" gap="10px" className="_responsive_row">
        <Box>
          <img 
            style={{ height: "66px", width: "66px", objectFit: "contain" }} 
            src={img} 
            alt={currency}
            onError={(e) => {
              const fallbackImages = {
                hbar: require('../../assets/common/resources/Hbar.png'),
                near: require('../../assets/common/resources/Near.png'),
                matic: require('../../assets/common/resources/Polygon.png'),
                siki: require('../../assets/common/resources/siki_token.svg')
              };
              
              if (isHbar) e.target.src = fallbackImages.hbar;
              else if (isNear) e.target.src = fallbackImages.near;
              else if (!notMatic) e.target.src = fallbackImages.matic;
              else e.target.src = fallbackImages.siki;
            }}
          />
        </Box>
        {loading ? (
          <Box>
            <Box sx={{ 
              width: '150px', 
              height: '20px', 
              backgroundColor: placeholderColor, 
              borderRadius: '4px',
              marginBottom: '8px'
            }} />
            <Box sx={{ 
              width: '100px', 
              height: '16px', 
              backgroundColor: placeholderColor, 
              borderRadius: '4px' 
            }} />
          </Box>
        ) : !accountId && isHbar ? (
          creating && isHbar ? (
            <LoadingButton
              loading
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
            >
              Creating wallet
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => onWalletCreate(true)}
              className="_generateButton"
            >
              Generate Wallet
            </Button>
          )
        ) : !accountId && isNear ? (
          createNear && isNear ? (
            <LoadingButton
              loading
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
            >
              Creating wallet
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => onWalletCreate(true)}
              className="_generateButton"
            >
              Generate Wallet
            </Button>
          )
        ) : !accountId && !notMatic ? (
          createMatic && !notMatic ? (
            <LoadingButton
              loading
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
            >
              Creating wallet
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => onWalletCreate()}
              className="_generateButton"
            >
              Generate Wallet
            </Button>
          )
        ) : (
          <Box>
            <Typography className="__logo_title">{balance}</Typography>
            <Typography variant="body2">{currency}</Typography>
            <Typography variant="body2" sx={{ wordBreak: " break-all" }}>
              {accountId}
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

// Maps a transaction-history tab to a predicate. Shared by the list filter and
// the earnings chart so the selected tab drives both. "all" matches everything.
const matchesTransactionFilter = (t, filter) => {
  switch (filter) {
    case "songRoyalties":
      return t.type === "royalty" && t.royaltyType !== "playlist" && t.source !== "livestream";
    case "livestreamRoyalties":
      return t.type === "royalty" && t.source === "livestream";
    case "playlistRoyalties":
      return t.type === "royalty" && t.royaltyType === "playlist";
    case "tips":
      return t.type === "tip";
    case "subscriptions":
      return t.type === "subscription";
    case "songRequests":
      return ["songRequest", "songRequestReceived", "songRequestRefund"].includes(t.type);
    case "all":
    default:
      return true;
  }
};

// Chart header copy per selected tab.
const TRANSACTION_FILTER_LABELS = {
  all: "Earnings",
  songRoyalties: "Song Royalties",
  livestreamRoyalties: "Live Royalties",
  playlistRoyalties: "Playlist Royalties",
  tips: "Tips",
  subscriptions: "Subscriptions",
  songRequests: "Song Requests",
};

export default function Wallet() {
  const { t } = useTranslation("common");
  const swapObject = getMemo();
  const { addBalance } = useParams();
  const dispatch = useDispatch();
  const { bal, hbar, matic } = useSelector((state) => state.balance);
  const [open, setOpen] = useState(false);
  const [raiseAmount, setRaiseAmount] = useState();
  const [HBARORUDSC, setHBARORUDSC] = useState(null);
  const [message, setMessage] = useState("");
  const [transactions, setTransactions] = React.useState([]);
  const [filteredTransactions, setFilteredTransactions] = React.useState([]);
  const [transactionFilter, setTransactionFilter] = React.useState("all");

  const getCachedWalletData = () => {
    try {
      const userData = getUserDetail();
      if (userData?.wallet) {
        const wallets = [
          {
            balance: userData.wallet.balance || 0,
            accountId: userData.wallet.accountId || null,
            currency: 'siki'
          },
          {
            balance: userData.wallet.polygonBalance || 0,
            accountId: userData.wallet.polygon?.publicAddress || null,
            currency: 'matic'
          },
          {
            balance: userData.wallet.hbarBalance || 0,
            accountId: userData.wallet.hbar?.publicKey || null,
            currency: 'hbar'
          },
          {
            balance: userData.wallet.nearBalance || 0,
            accountId: userData.wallet.near?.accountId || null,
            currency: 'near'
          }
        ];
        return wallets;
      }
    } catch (error) {
      console.error('Error loading cached wallet data:', error);
    }
    return [];
  };

  const [myBalance, setMyBalance] = React.useState(getCachedWalletData());
  const [loading, setLoading] = React.useState(false);
  const [balancesLoading, setBalancesLoading] = React.useState(true);
  const theme = useTheme();
  const palette = theme.palette || {};
  const paperColor =
    palette.background?.paper || "var(--paper-color, #090909)";
  const dividerColor =
    palette.divider ||
    `${palette.primary?.main || "var(--primary-color, #FFEE20)"}33`;
  const surfaceOverlay =
    palette.mode === "light"
      ? "rgba(0, 0, 0, 0.05)"
      : "rgba(255, 255, 255, 0.04)";
  const actionRowStyles = React.useMemo(() => {
    const primaryColor = palette?.primary?.main || "var(--primary-color, #FFEE20)";
    const textColor = palette?.text?.primary || "var(--text-primary, #FFFFFF)";
    const isLight = palette?.mode === "light";

    return {
      height: "54px",
      backgroundColor: surfaceOverlay,
      alignItems: "center",
      padding: "0 16px",
      borderRadius: "12px",
      cursor: "pointer",
      border: `1px solid ${dividerColor}`,
      transition:
        "background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease",
      color: textColor,
      boxShadow: isLight
        ? "0 8px 20px rgba(0, 0, 0, 0.08)"
        : "0 8px 20px rgba(0, 0, 0, 0.45)",
      "&:hover": {
        backgroundColor: isLight
          ? "rgba(0, 0, 0, 0.08)"
          : "rgba(255, 255, 255, 0.08)",
        borderColor: primaryColor,
        boxShadow: isLight
          ? "0 12px 28px rgba(0, 0, 0, 0.12)"
          : "0 12px 28px rgba(0, 0, 0, 0.5)",
      },
      "& .MuiTypography-root": {
        color: textColor,
        fontWeight: 600,
      },
    };
  }, [palette, surfaceOverlay, dividerColor]);
  const [value, setValue] = React.useState(0);
  const [fundingLink, setFundLink] = useState(null);
  const [isOpenOffboardingBox, setIsOpenOffboardingBox] = useState(false);
  const [amount, setAmount] = React.useState("");
  const [pageNo, setPageNo] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);
  const [creating, setCreating] = React.useState(false);
  const [createMatic, setCreateMatic] = React.useState(false);
  const [createNear, setCreateNear] = React.useState(false);
  const [newWindow, setNewWindow] = React.useState();
  const [openPayModel, setOpenPayModel] = React.useState(false);

  const getWalletBalance = async () => {
    try {
      setBalancesLoading(true);
      const response = await ApiService.BALANCE();
      setMyBalance(response["result"]["wallets"]);
      dispatch(getBalance(response));
      setBalancesLoading(false);
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      setBalancesLoading(false);
    }
  };
  const filterTransactions = (transactionList, filter) => {
    setFilteredTransactions(
      filter === "all"
        ? transactionList
        : transactionList.filter((t) => matchesTransactionFilter(t, filter))
    );
  };

  const handleFilterChange = (newFilter) => {
    setTransactionFilter(newFilter);
    filterTransactions(transactions, newFilter);
  };

  // Stable predicate so the chart only recomputes when the selected tab changes.
  const chartFilter = React.useCallback(
    (t) => matchesTransactionFilter(t, transactionFilter),
    [transactionFilter]
  );

  const getTransaction = async (next) => {
    try {
      setLoading(true);
      const response = await ApiService.TRANSACTIONS({
        pageNo: next,
        pageSize: 15,
      });
      setLoaded(response["result"].length < 15 ? true : false);
      const newTransactions = [...transactions, ...response["result"]];
      setTransactions(newTransactions);
      filterTransactions(newTransactions, transactionFilter);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getWalletBalance();
    getTransaction(pageNo);
  }, []);

  React.useEffect(() => {
    if (transactions.length > 0 && filteredTransactions.length === 0 && transactionFilter === "all") {
      setFilteredTransactions(transactions);
    }
  }, [transactions]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      getTransaction(pageNo);
    } else {
      setLoaded(false);
      setPageNo(1);
      setTransactions([]);
      setFilteredTransactions([]);
      setTransactionFilter("all");
    }
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const raiseLimit = async () => {
    const payload = {
      status: "pending",
      reqTokenLimit: raiseAmount,
      reason: message,
    };
    setLoading(true);
    try {
      const response = await ApiService.TOKEN_LIMIT_REQUEST(payload);
      setRaiseAmount(null);
      setMessage("");
      notifier.success(t("notifier.toast1"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const openOffboardingBox = () => {
    setIsOpenOffboardingBox(true);
  };
  const closeOffboardingBox = () => {
    setIsOpenOffboardingBox(false);
  };

  React.useEffect(() => {
    if (myBalance.length) {
      const tempBalance = myBalance;
      tempBalance[0]["balance"] = bal;
      setMyBalance({ ...tempBalance });
    }
  }, [bal]);
  React.useEffect(() => {
    if (addBalance && addBalance === "addBalance") setValue(1);
  }, [addBalance]);
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded) {
      const next = pageNo + 1;
      setPageNo(next);
      getTransaction(next);
    }
  };
  const createWallet = async (isHbar, isNear) => {
    try {
      const h = isHbar
        ? setCreating(true)
        : isNear
        ? setCreateNear(true)
        : setCreateMatic(true);
      const response = await ApiService.CREATE_MATIC(
        `?platform=${isHbar ? "hedera" : isNear ? "near" : "polygon"}`
      );
      setMyBalance(response["result"]["wallets"]);
      dispatch(getBalance(response));
      const b = isHbar
        ? setCreating(false)
        : createNear
        ? setCreateNear(false)
        : setCreateMatic(false);
    } catch (error) {
      setCreating(false);
      setCreateMatic(false);
      setCreateNear(false);
    }
  };

  const getPaypalLink = async (amount) => {
    if (amount >= 4.99 && amount <= 20000) {
      try {
        setLoading(true);
        const response = await ApiService.PAYPALLINK({
          amount: amount,
        });
        setLoading(false);
        setNewWindow(response["result"]["links"][1]["href"]);
        handleClosed();
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const doPaypalCashout = async (transferAmount, paypalAddress) => {
      try {
        const user = getUserDetail();
        setLoading(true);
        const payload = buildPaypalCashoutPayload({
          amount: transferAmount,
          accountEmail: user["email"],
          paypalAddress,
        });
        const response = await ApiService.OFFBOARD_CASHOUT(payload);

        setLoading(false);
        closeOffboardingBox();
        notifier.success(response[ "result" ]);
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
  };

  const redirect = () => {
    window.open(
      newWindow,
      "_blank",
      "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
    );
  };

  React.useEffect(() => {
    if (newWindow) {
      redirect();
    }
  }, [newWindow]);

  const handleOpen = () => {
    setOpenPayModel(true);
  };
  const handleClosed = () => {
    setOpenPayModel(false);
  };


  return (
    <Box id="walletBox">
      <Box sx={{ padding: "0 18px 32px 18px", position: "relative" }}>
        {/* Earnings-over-time chart, mirroring the homepage profit chart.
            Driven by the selected transaction-history tab below. */}
        <Box sx={{ mb: 3 }}>
          <MonetizationChart
            showWalletLink={false}
            height={200}
            txFilter={chartFilter}
            label={TRANSACTION_FILTER_LABELS[transactionFilter] || "Earnings"}
          />
        </Box>
        <Stack direction="row" gap="24px" className="responsive-flex" sx={{ alignItems: 'stretch', justifyContent: 'center' }}>
          <BalanceBox
            img={Images.tip_player}
            currency={`${t("wallet.text3")} SIKI Token`}
            balance={
              myBalance[0]?.balance
                ? myBalance[0]["balance"].toFixed(2)
                : "0.00"
            }
            notMatic={true}
            loading={balancesLoading}
          />
          <Box
            className="_flex_width"
            sx={{
              padding: "15px",
              backgroundColor: paperColor,
              borderRadius: "16px",
              border: `1px solid ${dividerColor}`,
              width: "30%",
              marginBottom: "1rem",
              boxShadow: palette.mode === "light"
                ? "0 14px 30px rgba(0, 0, 0, 0.08)"
                : "0 14px 30px rgba(0, 0, 0, 0.45)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: palette.mode === "light"
                  ? "0 16px 35px rgba(0, 0, 0, 0.12)"
                  : "0 16px 35px rgba(0, 0, 0, 0.55)",
              }
            }}
            onClick={() => setOpenPayModel(true)}
          >
            <Plus size="large" style={{ marginBottom: "12px", color: palette.primary?.main || "#FFEE20" }} />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "default",
                textAlign: "center",
                fontSize: "16px"
              }}
            >
              Buy More SIKI
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: palette.text?.secondary || "rgba(255, 255, 255, 0.7)",
                textAlign: "center",
                marginTop: "4px",
                fontSize: "12px"
              }}
            >
              Purchase via PayPal
            </Typography>
          </Box>
          <Box
            className="_flex_width"
            sx={{
              padding: "15px",
              backgroundColor: paperColor,
              borderRadius: "16px",
              border: `1px solid ${dividerColor}`,
              width: "30%",
              marginBottom: "1rem",
              boxShadow: palette.mode === "light"
                ? "0 14px 30px rgba(0, 0, 0, 0.08)"
                : "0 14px 30px rgba(0, 0, 0, 0.45)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: palette.mode === "light"
                  ? "0 16px 35px rgba(0, 0, 0, 0.12)"
                  : "0 16px 35px rgba(0, 0, 0, 0.55)",
              }
            }}
            onClick={() => openOffboardingBox()}
          >
            <ArrowUpwardIcon
              sx={{
                transform: "rotate(45deg)",
                fontSize: "32px",
                marginBottom: "12px",
                color: palette.primary?.main || "#FFEE20"
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "default",
                textAlign: "center",
                fontSize: "16px"
              }}
            >
              SIKI Cashout
            </Typography>
          </Box>
        </Stack>

        <Divider
          sx={{
            borderColor: dividerColor,
            backgroundColor: dividerColor,
            my: 3,
          }}
        />
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab id="tabShowTransactionHistory"
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={value === 0 ? Images.transction1 : Images.transction}
                alt="Add"
              />
            }
            label={t("wallet.tab1")}
            {...a11yProps(0)}
          />
        </Tabs>
        <Box
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          sx={{ maxHeight: "77vh", overflowY: "auto" }}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Box className="__main_pading">
              <Stack spacing={1} sx={{ position: "relative" }}>
                <Box sx={{ 
                  display: 'flex', 
                  gap: 1, 
                  mb: 2, 
                  flexWrap: 'wrap',
                  borderBottom: `1px solid ${dividerColor}`,
                  pb: 2
                }}>
                  <Button
                    variant={transactionFilter === "all" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("all")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    All
                  </Button>
                  <Button
                    variant={transactionFilter === "songRoyalties" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("songRoyalties")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Song Royalties
                  </Button>
                  <Button
                    variant={transactionFilter === "livestreamRoyalties" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("livestreamRoyalties")}
                    sx={{
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Live Royalties
                  </Button>
                  <Button
                    variant={transactionFilter === "playlistRoyalties" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("playlistRoyalties")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Playlist Royalties
                  </Button>
                  <Button
                    variant={transactionFilter === "tips" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("tips")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Tips
                  </Button>
                  <Button
                    variant={transactionFilter === "subscriptions" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("subscriptions")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Subscriptions
                  </Button>
                  <Button
                    variant={transactionFilter === "songRequests" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("songRequests")}
                    sx={{
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Song Requests
                  </Button>
                </Box>
                
                <Stack
                  onScroll={(e) => handleScroll(e.target)}
                  spacing={2}
                  sx={{ maxHeight: "73vh", overflow: "scroll" }}
                >
                  {filteredTransactions.length > 0 ? (
                    filteredTransactions.map((transaction, index) => (
                      <TransactionRow key={index} transaction={transaction} />
                    ))
                  ) : (
                    <NoData lable={t("noData.message20")} overlay={false} />
                  )}
                </Stack>
              </Stack>
            </Box>
          </TabPanel>
        </Box>
      </Box>
      {loading ? <Loader /> : null}

      <OffboardingBox
        open={isOpenOffboardingBox}
        handleClose={closeOffboardingBox}
        handleSubmit={(amount, paypalAddress) => {
          doPaypalCashout(amount, paypalAddress);
        }}
        loading={loading}
      />
      <LivestreamPayPopup
        open={openPayModel}
        handleClose={handleClosed}
        handleSubmit={(amount, type) => {
          getPaypalLink(amount);
        }}
        loading={loading}
        onlyPayPal={true}
      />
      {open ? (
        <QrPopup
          open={open}
          handleClose={() => setOpen(false)}
          params={{ walletId: swapObject, hbar: getHbar(), usdc: getUsdt() }}
          value={HBARORUDSC}
        />
      ) : null}
    </Box>
  );
}
